//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import jstz from "jstz";

import { iframeResizer } from "iframe-resizer";

import $ from "jquery";

import { validationMixin } from "vuelidate";
import { isValidNumber, parseNumber } from "libphonenumber-js";
import { required, email, numeric } from "vuelidate/lib/validators";

import qs from "qs";

import { mapState } from "vuex";

import storage from "local-storage-fallback";

import EofyModal25 from "~/components/forms/EofyModal25.vue";

import countryBlocker from "~/middleware/country";

import blockFile from "~/content/data/blockfile.json";

export default {
    data() {
        return {
            region: "au",
            localStorage: null,
            is_exception: false,

            blockedEmails: [],

            isShownEmailBlockPopup: true,

            location: {
                ip: "",
                country_code: "",
                country_name: "",
                time_zone: "",
                timestamp: "",
                latitude: "",
                longitude: "",
                zip: "",
            },

            first_name: "",
            last_name: "",
            phone: "",
            company: "",
            country: "",
            email: "",

            urgency: "",
            industry: "",
            user_type: "",
            referrer_party: "",
            volume: "",
            virtual_number: "Toll-Free Number",

            timezone: "",

            loading: false,
            countryListOpen: false,
            phoneFieldFocused: false,

            emailUpdated: false,
            phoneUpdated: false,

            email_opt_in: "on",

            countryList: [
                {
                    name: "Australia",
                    code: "AU",
                    dial: "61",
                },
                {
                    name: "Canada",
                    code: "CA",
                    dial: "1",
                },
                {
                    name: "Hong Kong",
                    code: "HK",
                    dial: "852",
                },
                {
                    name: "New Zealand",
                    code: "NZ",
                    dial: "64",
                },
                {
                    name: "Philippines",
                    code: "PH",
                    dial: "63",
                },
                {
                    name: "Singapore",
                    code: "SG",
                    dial: "65",
                },
                {
                    name: "United Kingdom",
                    code: "GB",
                    dial: "44",
                },
                {
                    name: "United States",
                    code: "US",
                    dial: "1",
                },
            ],
            errors: {
                email: "",
                phone: "",
                api: "",
                form: "",
            },
        };
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    mixins: [validationMixin],
    components: {
        EofyModal25,
    },
    validations: {
        email_opt_in: {
            required,
            checked(isChecked) {
                return isChecked === true;
            },
        },
        first_name: {
            required,
        },
        last_name: {
            required,
        },
        company: {
            required,
        },
        phone: {
            required,
            numeric,
            phone(phone) {
                if (phone === "") return true;
                const country = this.countrySelected.code;

                this.phoneUpdated = true;

                const isValid = isValidNumber(phone, country);
                if (isValid) {
                    this.phone = parseNumber(phone, country, {
                        extended: true,
                    }).phone;
                }
                return isValid;
            },
            submitErrors(phone) {
                if (this.phoneUpdated) return true;

                return this.errors.phone === "";
            },
        },
        email: {
            required,
            email,
            onUpdate(email) {
                this.emailUpdated = true;
                return true;
            },
            submitErrors(email) {
                if (this.emailUpdated) return true;

                return this.errors.email === "";
            },
        },
    },
    computed: {
        iframeURL() {
            if (!this.data.pardot) return null;
            if (typeof window === "undefined") return this.data.pardot;

            const search = new URLSearchParams(window ? window?.location?.search : "");

            search.append("Referrer", document?.referrer || (window ? window?.location.href : ""));
            search.append("Website_URL", window ? window?.location.href : "https://burstsms.com");
            search.append("Website_Source", "Burst US");

            return this.data.pardot + "?" + search.toString();
        },
        ...mapState({
            page: (state) => state.pages.page,
        }),
        formName() {
            return "EOFY Register - " + this.source;
        },
        url() {
            return (process.env.SITE_PATH || "https://burstsms.com") + this.$nuxt.$route.path;
        },
        source() {
            return this.region.toUpperCase();
        },
        subject() {
            return "EOFY Register - " + this.source + " - " + this.company;
        },
        phoneFull() {
            return this.countrySelected.dial + this.phone;
        },
        countrySelected() {
            const self = this;
            return (
                this.countryList.filter((c) => c.name === self.country)[0] || {
                    name: "Australia",
                    code: "AU",
                    dial: "61",
                }
            );
        },
        countryListReverse() {
            return [].sort.call(this.countryList, function (a, b) {
                return b.name.localeCompare(a.name);
            });
        },
    },
    async created() {
        const self = this;

        this.country = "Australia";
        this.region = "au";

        if (process.browser) {
            this.initIframeResizer();
        }

        if (this.page.region === "United States") {
            this.country = "United States";
            this.region = "us";
        }

        if (this.page.region === "New Zealand") {
            this.country = "New Zealand";
            this.region = "nz";
        }

        if (process.browser || process.client) {
            await countryBlocker(this.$nuxt.context);

            self.localStorage = !("localStorage" in window) ? storage : window.localStorage;

            const burstGeo = JSON.parse(self.localStorage.getItem("burst-geo-2"));

            if (burstGeo) {
                self.location.ip = burstGeo.ip || "";
                self.location.country_code = burstGeo.country_code || "";

                self.location.timestamp = new Date().toISOString().split(".")[0].replace("T", " ");

                if (burstGeo.data) {
                    self.location.country_name = burstGeo.data.country_name || "";
                    self.location.time_zone = burstGeo.data.time_zone.name || "";
                    self.location.zip = burstGeo.data.zipcode || "";
                    self.location.latitude = burstGeo.data.latitude || "";
                    self.location.longitude = burstGeo.data.longitude || "";
                }
            }

            const timezone = jstz.determine();
            if (typeof timezone !== "undefined") {
                this.timezone = timezone.name();
            }

            self.getBlockedEmails();

            $(function () {
                $("#offer-modal").modal({
                    show: false,
                });
                $("#offer-modal").on("shown.bs.modal", (event) => {
                    console.log(event);
                    self.initIframeResizer();
                });
                $("#terms-modal").modal({
                    show: false,
                });
                $("#email-block-popup").modal({
                    show: false,
                });

                $("#email-block-popup").appendTo("body");

                $("body").on("click", '[href="#offer"]', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(".modal.show").modal("hide");
                    $("#offer-modal").modal("show");
                });
                $("body").on("click", '[href="#terms"]', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $(".modal.show").modal("hide");
                    $("#terms-modal").modal("show");
                });

                if (window.location.hash === "#offer") {
                    $("#offer-modal").modal("show");
                }
                if (window.location.hash === "#terms") {
                    $("#terms-modal").modal("show");
                }
            });
        }
    },
    methods: {
        goSubmit() {
            // const formData = new FormData(this.$refs.form);
            const self = this;
            this.loading = true;

            window.localStorage.setItem(
                "burst-register",
                JSON.stringify({
                    name: this.first_name + " " + this.last_name,
                    country: this.region,
                    email: this.email,
                })
            );

            if (self.$v.$invalid) {
                self.focusInvalidField();
            }

            this.isEmailPhoneUnique()
                .then(function (response) {
                    if (response) {
                        const countriesWithSpamCheck = [self.region];
                        // const countriesWithSpamCheck = (process.env.SPAM_CHECK ?? "")
                        //   .toLocaleLowerCase()
                        //   .split(",") ?? ["us", "ca", "gb"];
                        if (!countriesWithSpamCheck.includes(self.region)) {
                            self.sendRegistration();
                        } else {
                            self.checkPhoneValidity().then(function (response) {
                                console.log("checkPhoneValidity", response);

                                if (response.data) {
                                    // Phone Valid
                                    const phoneErrorCodes = {
                                        "000": "Valid Query",
                                        "001": "Invalid Query Format",
                                        "002": "Query Service Invalid",
                                        "003": "Country Not Allowed",
                                        "004": "Country Code Invalid",
                                        "005": "Wrong Number Length or Format",
                                        "006": "Range Not Allocated",
                                        "007": "Number Not Found - Onboard",
                                        "008": "Number Not Found - Remote",
                                        "009": "Service Error",
                                        "010": "Remote Timeout",
                                        100: "Subscriber Error (Temporary)",
                                        101: "Subscriber Error",
                                        109: "Destination Network Error",
                                        112: "No network response",
                                        113: "Destination Error",
                                        114: "Destination Network Temporary Unavailable",
                                        200: "Remote Query Failed - GNR response provided",
                                        "V:1": "Fallback Error: Invalid Number",
                                        "V:2": "Fallback Error: Not allowed country",
                                    };

                                    let errorCodeMessage = "";

                                    if (phoneErrorCodes[response.data.rc] !== null) {
                                        errorCodeMessage = phoneErrorCodes[response.data.rc] ?? `RC:${response.data.rc}`;
                                    }

                                    if (response.data.rc === "000") {
                                        // Phone Valid. Proceed to email checking
                                        self.checkEmailValidity().then(function (response) {
                                            console.log("checkEmailValidity", response);

                                            self.is_exception = false;

                                            if (response.data) {
                                                const validCodes = ["valid", "catch-all"];
                                                const exceptions = [];

                                                if (validCodes.includes(response.data.status)) {
                                                    // Email Valid. Proceed to send registration
                                                    self.sendRegistration();
                                                } else if (exceptions.includes(response.data.sub_status)) {
                                                    // Email Valid with exceptions. Proceed to send registration
                                                    self.is_exception = true;
                                                    self.sendRegistration();
                                                } else {
                                                    const catchCodes = ["do_not_mail"];

                                                    if (catchCodes.includes(response.data.status)) {
                                                        self.catchEmailSpamCheck(response.data);
                                                    } else {
                                                        self.setErrorByCode("INVALID_EMAIL");
                                                    }

                                                    self.callRegistrationFailed({
                                                        type: "email",
                                                        email: self.email,
                                                        phone: self.phoneFull,
                                                        data: response.data,
                                                        error: errorCodeMessage,
                                                    });
                                                }
                                            } else {
                                                self.setErrorByCode("API_FAIL");

                                                self.callRegistrationFailed({
                                                    type: "email",
                                                    email: self.email,
                                                    phone: self.phoneFull,
                                                    data: response.data,
                                                    error: errorCodeMessage,
                                                });
                                            }
                                        });
                                    } else {
                                        self.setErrorByCode("BANNED_NUMBER");

                                        self.callRegistrationFailed({
                                            type: "phone",
                                            email: self.email,
                                            phone: self.phoneFull,
                                            data: response.data,
                                            error: errorCodeMessage,
                                        });
                                    }
                                } else {
                                    self.setErrorByCode("API_FAIL");

                                    self.callRegistrationFailed({
                                        type: "phone",
                                        email: self.email,
                                        phone: self.phoneFull,
                                        data: response.data,
                                        error: "API_FAIL",
                                    });
                                }
                            });
                        }
                    } else {
                        self.focusInvalidField();
                        self.loading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    self.setErrorByCode("FAILED");
                });
        },
        checkPhoneValidity() {
            const self = this;

            return this.$axios({
                url: "/.netlify/functions/check-phone",
                baseURL: "/",
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                    Expires: 0,
                },
                data: qs.stringify({
                    phone: self.phoneFull,
                }),
            });
        },
        callRegistrationFailed(data) {
            // this.setErrorByCode('API_FAIL');
            this.loading = false;

            const notificationData = {
                type: "error",
                message: "Registration Error",
            };

            if (data.type === "email") {
                notificationData.message = "Check Email. " + data.data.status + " " + data.data.sub_status;
            }

            if (data.type === "phone") {
                notificationData.message = "Check Phone. " + data.error;
            }

            // Trigger Slack Call
            this.sendSlackNotification(notificationData);
        },
        async sendSlackNotification(data) {
            const self = this;

            await this.recordZapier({ status: data.type, error: data.message });

            const sendSlack = await this.$axios({
                url: "/.netlify/functions/send-slack",
                baseURL: "/",
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                    Expires: 0,
                },
                data: qs.stringify({
                    url: window.location.href,
                    type: data.type,
                    message: data.message,
                    name: self.first_name + " " + self.last_name,
                    email: self.email,
                    company: self.company,
                    phone: self.phoneFull,
                    country: self.countrySelected.name,
                }),
            });

            return sendSlack;
        },
        async recordZapier(overrides) {
            const data = {
                form: {
                    status: "Success",
                    error: "-",
                    location: this.location,
                    country: this.country,
                    country_code: this.countrySelected.code,
                    name: this.first_name + " " + this.last_name,
                    name_company: this.company,
                    email: this.email,
                    phone: this.phoneFull,
                    virtual_number: this.virtual_number,
                    source: window?.location.href || "https://burstsms.com",
                },
            };

            if (overrides) {
                data.form = { ...data.form, ...overrides };
            }

            const recordZapierRequest = await $.ajax({
                type: "POST",
                url: process.env.FT_ZAP_REG,
                data,
                dataType: "json",
            });

            return recordZapierRequest;
        },
        catchEmailSpamCheck(data) {
            this.setErrorByCode("CATCH_EMAIL");

            // window.location.assign('https://contact.burstsms.com/?' + qs.stringify({
            //   name: this.name,
            //   company: this.company,
            //   email: this.email,
            //   phone: this.phoneFull,
            // }));
        },

        sendPardot() {
            const self = this;

            self.loading = true;

            const params = {
                // oid: "00D5i000003KHOk",
                // retURL: (window?.location.origin || "https://burstsms.com") + `/${this.region}-sms-marketing-eofy-thank-you/`,
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                // website: this.url,
                company_name: this.company,
                mobile: this.countrySelected.dial + this.phone,
                email_opt_in: this.email_opt_in,
                // phone: this.countrySelected.dial + this.phone,
                virtual_number: this.virtual_number,

                website_url: window?.location.href || "https://burstsms.com", // Website URL
                source_referrer: document?.referrer || window?.location.href, // Referrer

                // "00N5i00000Cl5QK": "Burst US", // Website_S__c *
                // "00N5i00000ClpEd": "EOFY23", // Page *
                website_source: "Trial", // Form *

                // // Regions
                country: this.country,
                country_code: this.countrySelected.code || "", // Source__c

                // // Geolocation
                geo_country_code: this?.location?.country_code || "", // Country_Code__c
                // "00N5i000009uP1H": this.location ? this.location.country_name : "", // Country__c
                // "00N5i00000JPJJz": this.location ? this.location.zip : "", // PostalCode
                // "00N5i00000ClpLQ": this.location.timestamp, // Timestamp
                timezone: this.location.time_zone || "", // Timezone__c
                // "00N5i00000CnLjF": this.location ? this.location.ip : "", // IP__c
                // "00N5i00000CnM15": this.location ? this.location.latitude : "", // Latitude__c
                // "00N5i00000CnM1K": this.location ? this.location.longitude : "", // Longitude__c
            };

            params.utm_campaign = this.getParameterByName("utm_campaign");
            params.utm_content = this.getParameterByName("utm_content");
            params.utm_medium = this.getParameterByName("utm_medium");
            params.utm_source = this.getParameterByName("utm_source");
            params.utm_term = this.getParameterByName("utm_term");
            params.gclid = this.getParameterByName("gclid");

            const form = document.createElement("form");
            form.style.display = "none";
            form.setAttribute("method", "POST");
            form.setAttribute("action", process.env.PARDOT_TRIAL);

            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", params[key]);
                    form.appendChild(hiddenField);
                }
            }

            document.body.appendChild(form);

            form.addEventListener("submit", function () {
                window.location.assign("/au-sms-marketing-eofy-thank-you/");
                self.loading = false;
            });

            form.submit();
        },
        sendSalesforce() {
            const params = {
                oid: "00D5i000003KHOk",
                retURL: (window?.location.origin || "https://burstsms.com") + `/${this.region}-sms-marketing-eofy-thank-you/`,
                first_name: this.first_name,
                last_name: this.last_name,
                Email__c: this.email,
                website: this.url,
                company: this.company,
                mobile: this.countrySelected.dial + this.phone,
                phone: this.countrySelected.dial + this.phone,
                "00N5i00000ClpaC": this.virtual_number,

                "00N5i00000JLBIt": window?.location.href || "https://burstsms.com", // Website URL
                "00N5i000009uOiY": document?.referrer || window?.location.href, // Referrer

                "00N5i00000Cl5QK": "Burst US", // Website_S__c *
                "00N5i00000ClpEd": "EOFY23", // Page *
                "00N5i00000ClpEn": "Trial", // Form *

                // Regions
                country: this.country,
                "00N5i000009uOj2": this.countrySelected.code || "", // Source__c

                // Geolocation
                "00N5i00000JPIOy": this?.location?.country_code || "", // Country_Code__c
                "00N5i000009uP1H": this.location ? this.location.country_name : "", // Country__c
                "00N5i00000JPJJz": this.location ? this.location.zip : "", // PostalCode
                "00N5i00000ClpLQ": this.location.timestamp, // Timestamp
                "00N5i00000ClpKr": this.location.time_zone || "", // Timezone__c
                "00N5i00000CnLjF": this.location ? this.location.ip : "", // IP__c
                "00N5i00000CnM15": this.location ? this.location.latitude : "", // Latitude__c
                "00N5i00000CnM1K": this.location ? this.location.longitude : "", // Longitude__c
            };

            const form = document.createElement("form");
            form.style.display = "none";
            form.setAttribute("method", "POST");
            form.setAttribute("action", "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8");

            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", params[key]);
                    form.appendChild(hiddenField);
                }
            }

            document.body.appendChild(form);

            form.addEventListener("submit", function () {
                window.location.assign("/au-sms-marketing-eofy-thank-you/");
            });

            const formData = new FormData(form);

            const formString = JSON.stringify(Object.fromEntries(formData));
            console.log(formString);
            this.addHeapEvent("SF Data Sent", JSON.parse(formString));
            form.submit();
        },
        getParameterByName(name) {
            // eslint-disable-next-line no-useless-escape
            name = name.replace(/[\[]/, "[").replace(/[\]]/, "]");
            // eslint-disable-next-line no-useless-escape
            const regex = new RegExp("[\?&]" + name + "=([^&#]*)");
            const results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },
        checkEmailValidity() {
            const self = this;

            return this.$axios({
                url: "/.netlify/functions/check-email",
                baseURL: "/",
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                    Expires: 0,
                },
                data: qs.stringify({
                    email: self.email,
                    source: window?.location.href || navigator.userAgent || "https://burstsms.com",
                    ip: self.location.ip,
                }),
            });
        },
        sendRegistration() {
            this.loading = true;

            const self = this;

            const formData = {
                timezone: this.timezone,
                country_code: this.countrySelected.code,
                contact_me: "yes",
                reseller_id: process.env.resellerID || "",
                name: this.first_name + " " + this.last_name,
                name_company: this.company,
                email: this.email,
                region: this.source,
                phone: this.phoneFull,
                urgency: this.urgency,
                industry: this.industry,
                user_type: this.user_type,
                referrer_party: this.referrer_party,
                volume: this.volume,
                virtual_number: this.virtual_number,
            };

            if (formData.virtual_number === "I&apos;m not sure") {
                formData.virtual_number = "Unsure";
            }

            formData.location = self.location;
            formData.country = self.country;
            formData.ip = self.location.ip || "";
            formData.ip_country = self.location.country_code || "";
            formData.source = document.location.toString();
            formData.timestamp = new Date().toISOString().split(".")[0].replace("T", " ");

            self.$axios({
                method: "POST",
                url: process.env.FT_ZAP,
                data: qs.stringify({ form: formData }),
            });

            self.localStorage.setItem(
                "burst-register",
                JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    region: self.countrySelected.name,
                    country: self.countrySelected.code,
                    company: formData.name_company,
                    phone: formData.phone,
                    reseller: self.reseller,
                })
            );

            self.sendSlackNotification({
                type: "success",
                message: "Account Created" + (self.is_exception ? ". Email Exception." : ""),
            });

            self.sendPardot();

            return true;
        },
        phoneOnFocus() {
            this.phoneFieldFocused = true;
        },
        phoneOnChange() {
            this.$v.phone.$touch();
        },
        changeCountry(country) {
            if (this.countryListOpen) {
                if (this.country !== country) {
                    this.country = country;

                    if (this.phone.length > 0) {
                        this.phoneOnChange();
                    }
                }
            }
            this.toggleCountryList();
        },
        toggleCountryList() {
            this.$v.phone.$touch();
            this.countryListOpen = !this.countryListOpen;
        },
        async onSubmit() {
            const self = this;

            this.$v.$touch();
            if (this.$v.$invalid) {
                this.focusInvalidField();
            } else {
                try {
                    const token = await this.$recaptcha.execute("register_eofy");

                    // send token to server alongside your form data
                    this.loading = true;
                    this.$axios({
                        url: "/.netlify/functions/captcha",
                        baseURL: "/",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "Cache-Control": "no-cache, no-store, must-revalidate",
                            Pragma: "no-cache",
                            Expires: 0,
                        },
                        data: qs.stringify({
                            token,
                        }),
                    }).then(function (response) {
                        if (response?.data?.success && response?.data?.score > 0.5) {
                            self.goSubmit();
                        } else {
                            self.setErrorByCode("API_FAIL");
                        }
                    });
                } catch (error) {
                    console.error("Login error:", error);
                    self.setErrorByCode("API_FAIL");
                }
            }
        },
        catchSpamError(data) {
            window.location.assign(
                "https://contact.burstsms.com/?" +
                    qs.stringify({
                        r: this.region,
                        name: this.first_name + " " + this.last_name,
                        company: this.company,
                        email: this.email,
                        phone: this.phoneFull,
                    })
            );
        },
        focusInvalidField() {
            const _fields = [
                { id: "email_opt_in", name: "email_opt_in" },
                { id: "first_name", name: "First Name" },
                { id: "last_name", name: "Last Name" },
                { id: "company", name: "Company Name" },
                { id: "email", name: "Email" },
                { id: "phone", name: "Mobile Number" },
            ];

            for (let i = 0; i < _fields.length; i++) {
                if (this.$v[_fields[i].id].$invalid) {
                    this.$refs.form.querySelector('[name="' + _fields[i].name + '"]').focus();
                    break;
                }
            }
        },
        _classValid(field) {
            let _class = "";
            if (this.$v[field].$dirty) {
                _class += "is-dirty ";

                if (this.$v[field].$pending) {
                    _class += "is-loading ";
                    return _class;
                }
                if (this.$v[field].$invalid) {
                    _class += "is-invalid ";
                } else {
                    _class += "is-valid ";
                }
            }

            if (field === "phone") {
                if (this.phoneFieldFocused) _class += "is-focused ";
            }

            return _class;
        },
        isNumber(event) {
            if (isNaN(Number(event.key))) {
                return event.preventDefault();
            }
        },
        getBlockedEmails(cursor = 0) {
            const self = this;
            this.$axios.get(`https://secure.burstsms.com/api/1.1/obj/blocklistemail?cursor=${cursor}`).then(function (response) {
                if (response.data) {
                    const blockedEmails = response.data.response.results.map(function (result) {
                        return result.Email;
                    });

                    self.blockedEmails = [...self.blockedEmails, ...blockedEmails];

                    if (response.data.response.remaining > 0) {
                        self.getBlockedEmails(response.data.response.cursor + response.data.response.count);
                    }
                }
            });
        },
        isEmailPatternBlocked(email) {
            const [emailName, emailDomain] = email.split("@");

            if (emailName.split(".").length > 3) return true;
            if (emailDomain.split(".").length > 4) return true;

            return false;
        },
        showEmailBlockPopup() {
            $("#email-block-popup").modal("show");
        },
        isEmailDomainBlocked(email) {
            const emailDomain = email.split("@").pop();

            const blockPatterns = [".co.site", "co.site>"];
            const customDomains = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com"];
            const allowedDomains = [];

            const hasBlockingPattern = blockPatterns.some((pattern) => email.includes(pattern));
            if (hasBlockingPattern) return true;

            if (customDomains.includes(emailDomain)) return true;
            if (allowedDomains.includes(emailDomain)) return false;

            if (blockFile.includes(emailDomain) || this.blockedEmails.includes(emailDomain) || this.blockedEmails.includes(this.email)) return true;

            return false;
        },
        isEmailPhoneUnique() {
            const self = this;

            return new Promise((resolve, reject) => {
                self.errors.email = "";
                self.errors.phone = "";

                // Check if email is blocked
                if (self.isEmailPatternBlocked(self.email)) {
                    self.setErrorByCode("INVALID_EMAIL_PATTERN");
                    self.sendSlackNotification({
                        type: "email",
                        message: "Check Email Pattern. Blocklisted",
                    });
                    reject(new Error("Email Blocklisted", { email: self.email }));
                } else if (self.isEmailDomainBlocked(self.email)) {
                    // self.catchEmailSpamCheck({ email: self.email });
                    self.showEmailBlockPopup();
                    self.setErrorByCode("INVALID_DOMAIN");
                    self.sendSlackNotification({
                        type: "email",
                        message: "Check Email. Blocklisted",
                    });
                    reject(new Error("Email Blocklisted", { email: self.email }));
                } else {
                    self.$axios
                        .post(
                            "/validate-registration",
                            qs.stringify({
                                email: self.email,
                                phone: self.phoneFull,
                            })
                        )
                        .then(function (response) {
                            if (response.data) {
                                const validationErrors = response.data;
                                self.loading = false;
                                if (typeof validationErrors === "object") {
                                    if (validationErrors.length > 0) {
                                        let i = 0;
                                        for (i = 0; i < validationErrors.length; i++) {
                                            self.setErrorByCode(validationErrors[i]);
                                        }

                                        resolve(false);
                                    } else {
                                        resolve(true);
                                    }
                                } else {
                                    const apiError = new Error("/validate-registration: API Response Invalid");
                                    self.$bugsnag.notify(apiError, {
                                        metadata: {
                                            error: {
                                                string: JSON.stringify(validationErrors),
                                            },
                                        },
                                    });
                                    self.setErrorByCode("API_FAIL");
                                    reject(apiError);
                                }
                            } else {
                                resolve(false);
                            }
                        })
                        .catch((err) => {
                            self.$bugsnag.notify(new Error("Form Validation Error", { cause: err }), function (event) {
                                event.addMetadata("error", "string", JSON.stringify(err));
                            });
                            self.setErrorByCode("API_FAIL");
                            reject(err);
                        });
                }
            });
        },
        setHeapIdentity(id) {
            if (typeof window.heap !== "undefined") {
                // window.heap.resetIdentity();
                console.log("Heap", id);
                window.heap.identify(id);
            }
        },
        addHeapEvent(name, data) {
            if (typeof window.heap !== "undefined") {
                window.heap.track(name, data);
            }
        },
        setErrorByCode(error) {
            let message = "We encountered an error while processing your request.";
            this.errors.form = message;
            this.emailUpdated = false;
            this.phoneUpdated = false;

            if (error) {
                if (typeof error === "string") {
                    switch (error) {
                        case "EXISTING_ACCOUNT":
                        case "INVALID_EMAIL":
                            message = "Email address already in use. Please <a href='https://burst.transmitsms.com/login' target='_blank'>log in</a> or <a href='https://help.burstsms.com/s/submit-ticket' target='_blank'>contact us</a> for support.";
                            this.errors.email = message;
                            break;
                        case "INVALID_EMAIL_PATTERN":
                            message = "Email Address is not accepted. Please <a href='https://help.burstsms.com/s/submit-ticket' target='_blank'>contact us</a> for support.";
                            this.errors.email = message;
                            break;
                        case "INVALID_DOMAIN":
                            message = "Email domain is not accepted. Please <a href='https://help.burstsms.com/s/submit-ticket' target='_blank'>contact us</a> for support.";
                            this.errors.email = message;
                            break;
                        case "CATCH_EMAIL":
                            message =
                                "We cannot accept <span class='x-tooltip'>catch all<div class='x-tooltip-html'><div class='x-tooltip-close'>&times;</div>Because our application uses your email for functions such as billing and alerts you need to use a real email address, catch all or aliased emails such as info@ or support@ get blocked by certain email email systems and important communications can get lost. If you do not have access to a real email address you can talk to <a href='https://contact.burstsms.com' target='_blank'>Sales</a> or contact <a href='https://help.burstsms.com/s/submit-ticket' target='_blank'>Support</a>.</div></span> emails for registration.";
                            this.errors.email = message;
                            break;
                        case "VIRTUAL_NUMBER":
                        case "BANNED_NUMBER":
                            message = 'The number you have entered is invalid. Please try a different number or <a href="#live-chat">contact us</a> for support.';
                            this.errors.phone = message;
                            break;

                        case "EXISTING_NUMBER":
                            message = "The number you have entered is already in use. For support or if you need a second account, <a href='https://help.burstsms.com/s/submit-ticket' target='_blank'>contact us</a>.";

                            this.errors.phone = message;
                            break;

                        case "API_FAIL":
                            message = "We encountered an error while processing your request.";
                            this.errors.api = message;
                            this.loading = false;
                            break;

                        default:
                            message = "We encountered an error while processing your request.";
                            this.errors.form = message;
                            this.loading = false;
                    }
                }
            }

            return message;
        },

        initIframeResizer() {
            const self = this;
            iframeResizer(
                {
                    log: false,
                    checkOrigin: false,
                    heightCalculationMethod: "max",
                    onResized(data) {
                        data.fontSize = parseFloat(window ? window.getComputedStyle(document.body).getPropertyValue("font-size") : 16);
                        data.iframe.iFrameResizer.sendMessage(data);
                    },
                    onMessage({ iframe, message }) {
                        if (message.includes("submitted")) {
                            if (self.data.linkedin_conversion_id) {
                                console.log("LinkedIn Tracking Conversion ID: ", self.data.linkedin_conversion_id);
                                window.lintrk("track", { conversion_id: self.data.linkedin_conversion_id });
                            }
                        }
                    },
                },
                this.$refs.myIframe
            );
        },
    },
};
